import styled from 'styled-components';
import COLORS from 'shared/constants/colors';

const Container = styled.div`
  padding-bottom: 20px;
`;
const DialogTitle = styled.div`
  font-weight: 100;
  font-size: 24px;
  margin: 0 23px;
  margin-bottom: 10px;
  color: ${COLORS.BODY_TEXT};
  border-bottom: 2px solid #666;
  padding: 15px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Wrapper = styled.div`
  padding: 23px;
`;

const Row = styled.div`
  display: flex;
  grid-gap: 20px;
  margin-bottom: 20px;
`;

const Heading = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  border-bottom: 1px solid #eee;
  align-items: center;

  > h3 {
    font-weight: 600;
    font-size: 14px;
    margin: 0;
    color: ${COLORS.BODY_TEXT};
  }
  > button {
    color: ${COLORS.BLACK};
  }
`;

const CloudWrapper = styled.div`
  display: flex;
  align-items: center;
  grid-gap: 5px;
  width: 100%;
  > div {
    width: 100%;
  }
  > svg {
    cursor: pointer;
  }
  > img {
    width: 34px;
    height: auto;
    max-height: 34px;
  }
`;

const FieldWrapper = styled.div`
  flex: 1;
`;

const Update = styled.div`
  display: flex;
  justify-content: flex-end;

  > button {
    background-color: ${COLORS.BLACK};
    font-size: 14px;
    border-radius: 3px;
    padding: 12px;
    line-height: 1.5;
    color: ${COLORS.WHITE};
    :hover {
      opacity: 0.8;
      background-color: ${COLORS.BLACK};
      color: ${COLORS.WHITE};
    }
  }
`;

export {
  Container,
  DialogTitle,
  Wrapper,
  Row,
  Heading,
  CloudWrapper,
  FieldWrapper,
  Update,
};
